import React from 'react'

import './footer.sass'

export function Footer(): JSX.Element {
    return (
        <div className="footer-component">
            <img src={`${process?.env?.PUBLIC_URL || ""}/static/imgs/5glab.png`} id="lab5g" alt="5g lab logo" />
            <img src={`${process?.env?.PUBLIC_URL || ""}/static/imgs/techunited.png`} alt="tech united logo"/>
        </div>
    )
}